import { createBrowserRouter } from "react-router-dom";
import { ProtectedLayout } from "./components/ProtectedLayout";
import { AdminGuard } from "./components/AdminGuard";
import { ComingSoon } from "./components/ComingSoon";
import { LoginPage } from "./features/auth/LoginPage";
import { ForgotPasswordPage } from "./features/auth/ForgotPasswordPage";
import { ResetPasswordPage } from "./features/auth/ResetPasswordPage";
import { AcceptInvitationPage } from "./features/auth/AcceptInvitationPage";
import { HomePage } from "./features/home/HomePage";
import { AccountPage } from "./features/account/AccountPage";
import { AdminPage } from "./features/admin/AdminPage";
import { CollectionsAdminPage } from "./features/admin/CollectionsAdminPage";
import { SystemStatusPage } from "./features/admin/SystemStatusPage";
import { LibraryPage } from "./features/library/LibraryPage";
import { SourceDetailPage } from "./features/library/SourceDetailPage";
import { ImportPage } from "./features/import/ImportPage";
import { PodcastPage } from "./features/podcast/PodcastPage";
import { PodcastAdminPage } from "./features/podcast/PodcastAdminPage";
import { ChatPage } from "./features/chat/ChatPage";

export const router = createBrowserRouter([
  { path: "/login", element: <LoginPage /> },
  { path: "/forgot-password", element: <ForgotPasswordPage /> },
  { path: "/reset-password", element: <ResetPasswordPage /> },
  { path: "/accept-invitation", element: <AcceptInvitationPage /> },
  {
    path: "/",
    element: <ProtectedLayout />,
    children: [
      { index: true, element: <HomePage /> },
      { path: "chat", element: <ChatPage /> },
      { path: "library", element: <LibraryPage /> },
      { path: "library/:id", element: <SourceDetailPage /> },
      { path: "podcast", element: <PodcastPage /> },
      { path: "account", element: <AccountPage /> },
      {
        path: "admin",
        element: <AdminGuard />,
        children: [
          { index: true, element: <AdminPage /> },
          { path: "collections", element: <CollectionsAdminPage /> },
          { path: "system", element: <SystemStatusPage /> },
          { path: "podcast", element: <PodcastAdminPage /> }
        ]
      },
      {
        path: "import",
        element: <AdminGuard />,
        children: [{ index: true, element: <ImportPage /> }]
      }
    ]
  },
  { path: "*", element: <ComingSoon title="Nicht gefunden" note="Diese Seite gibt es nicht." /> }
]);
